<script>
    /*
    	LandingPageContent.svelte
    */

    import { onMount } from 'svelte';
    import { AccountStore } from "../../common/account";
    import { push } from 'svelte-spa-router';
    import { masterSearch } from '../../common/master-objects.js';

    // Icons
    import MdErrorOutline from 'svelte-icons/md/MdErrorOutline.svelte'

    // TCARE components
    import LandingPageTextButton from './LandingPageTextButton.svelte';

    export let onLoginClick;
    export let onSearch;
    export let isRunningSearch;
    export let isShowingZipError;

    onMount(() => {
    })

    const onZipInputKeyup = (e) => {
        if (e.key === 'Enter' && $masterSearch.location.postalCode.length === 5) {
            onSearch();
        }
    }

    const onMyResourcesClick = () => {
        push('/my-resources');
    }

    const focusElement = (elem) => {
        elem.focus();
    }

</script>

<style>
    .landing-page-content {
        position: relative;
        width: 100%;
        top: 135px;
        min-height: calc(100vh - 235px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: white;
        background-color: var(--tcui-dark-purple);
        /* border: 1px solid gold; */
    }

    /* holds two blocks */
    .landing-page-content .block-row {
        width: 1200px;
        /* min-width: 1100px; */
        margin: auto;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        /* border: 1px solid red; */
    }




    /* TEXT STYLES */

    .landing-page-content .text-1 {
        color: var(--tcui-secondary);
        font-size: 48px;
        /* font-weight: 500; */
        line-height: 80px;
        display: flex;
    }

    .landing-page-content .text-2 {
        margin-top: -10px;
        color: var(--tcui-cream);
        font-family: 'Newsreader';
        font-size: 26px;
        font-weight: 200;
        line-height: 28px;
    }

    .landing-page-content .text-3 {
        color: var(--tcui-white);
        font-size: 36px;
        font-weight: 300;
        line-height: 60px;
    }

    .landing-page-content .text-4 {
        width: 80%;
        color: var(--tcui-cream);
        font-family: 'Newsreader';
        font-size: 24px;
        font-weight: 200;
        line-height: 32px;
    }

    .landing-page-content .text-5 {
        width: 80%;
        color: #FE4672;
        font-family: 'Newsreader';
        font-size: 24px;
        font-weight: 200;
        line-height: 32px;
    }


    .landing-page-content .molecule {
        width: 85px;
        margin-left: 10px;
    }

    .landing-page-content .spacer-h {
        height: 50px;
    }


    .landing-page-content .block-left {
        width: 70%;
        /* border: 1px solid white; */
    }

    .landing-page-content .block-right {
        width: 320px;
        /* border: 1px solid white; */
    }

    .landing-page-content .top-image img {
        display: none;
        width: 150px;
        margin: 20px;
    }

    .landing-page-content .buttons-row {
        height: 55px;
        margin-top: 30px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .zip-input {
        width: 110px !important;
        padding: 15px 20px;
        margin-right: 25px;
        font-size: 16px;
        font-weight: 400;
        background-color: var(--tcui-white);
        border: none;
        border-radius: 25px;   
        outline: none; 
    }

    .search-button {
        /* min-width: 120px; */
        padding: 15px 20px;
        font-size: 15px;
        /* font-weight: 600; */
        color: var(--tcui-white);
        background-color: var(--tcui-primary);
        border: none;
        border-radius: 25px;
    }

    .search-button.my-resources{
        padding: 10px 20px;
    }

    .search-button:hover {
        background-color: var(--tcui-secondary);
    }

    .search-button:disabled {
        background-color: #41285B;
    }

    .search-button .button-content {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        /* border: 1px solid green; */
    }

    .search-button img {
        width: 16px !important;
        height: 16px !important;
        margin-left: 5px;
        margin-top: 1px;
    }

    .search-button.my-resources img {
        width: 24px !important;
        height: 28px !important;
        margin-left: 5px;
    }

    /* the big SVG shape */
    .landing-page-content img {
        width: 100%;
    }

    .flex-block {
        width: 50%;
    }

    .flex-block-100 {
        width: 100%;
    }

    .error-icon {
        color: #FE4672;
        width: 24px;
        height: 24px;
    }


    :global(.landing-page-content .login-button button) {
        margin-left: 0px;
        background: var(--tcui-primary);
    }

    @media screen and (max-width: 600px) {
        .landing-page-content {
            min-height: 1500px;
        }

        .landing-page-content .top-image img {
            display: block;
        }

        .landing-page-content .block-row {
            width: 90%;
        }

        .landing-page-content .block-left {
            width: 100%;
        }

        .landing-page-content .block-right {
            display: none;
        }

        /*
        .landing-page-content .text-1 { font-size: 48px; }
        .landing-page-content .text-2 { font-size: 48px; }
        .landing-page-content .text-3 { font-size: 48px; }
        .landing-page-content .text-4 { font-size: 48px; }
        */

    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
        .landing-page-content .top-image img {
            display: block;
        }

        .landing-page-content .block-row {
            width: 90%;
        }

        .landing-page-content .block-left {
            width: 100%;
        }

        .landing-page-content .block-right {
            display: none;
        }

        /*
        .landing-page-content .text-1 { font-size: 48px; }
        .landing-page-content .text-2 { font-size: 48px; }
        .landing-page-content .text-3 { font-size: 48px; }
        .landing-page-content .text-4 { font-size: 48px; }
        */

    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="landing-page-content">
    <!--
    <div class="top-image">
        <img src='/img/landing_page_shape.svg' alt='colored shape' draggable="false">        
    </div>
    -->

    <div class="block-row">
        <div class="block-left">

            <div class="text-1">Welcome to TCARE Connect
                <img class="molecule" src='/img/molecular_ruby.svg' alt='colored shape' draggable="false">
            </div>
            <div class="text-2">Providing family caregivers with resources to care better.</div>
            <div class="spacer-h"></div>

            <div class="flex-row">
                {#if $AccountStore.isLoggedIn}

                    <div class="flex-block">
                        <div class="text-3">Start Here.</div>
                        <div class="text-4">Enter a ZIP Code to search for resources available to support your caregiving needs.</div>
                        <div class="buttons-row">
                            <div class="input-wrapper">
                                <!-- using Svelte use: directive as better way to autofocus input -->
                                <input class="zip-input"
                                    use:focusElement
                                    maxlength="5"
                                    placeholder="Enter ZIP Code"
                                    on:keyup={onZipInputKeyup}
                                    bind:value={$masterSearch.location.postalCode}
                                       onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                                />
                            </div>
                            <button class="search-button" disabled={$masterSearch.location.postalCode.length !== 5} on:click={$masterSearch.location.postalCode.length === 5 && onSearch}>
                                <div class="button-content">
                                    <div>Search</div>
                                    <img src='/img/search.png' alt='colored shape' draggable="false">
                                </div>
                            </button>
                        </div>
                        {#if $isShowingZipError}
                            <div style="display:flex; flex-direction:row; align-items:center">
                                <div class="error-icon" style="margin-top:.5em">
                                    <MdErrorOutline />
                                </div>
                                <div style="margin-top:.5em; color: #FE4672; padding-left: .25em">Please enter a valid ZIP Code.</div>
                            </div>
                        {/if}
                    </div>

                    <div class="flex-block">
                        <div class="text-3">Saved a Resource?</div>
                        <div class="text-4">Keep track of resources you are interested in to access anytime, from anywhere.</div>
                        <div class="buttons-row">
                            <button class="search-button my-resources" on:click={onMyResourcesClick}>
                                <div class="button-content">
                                    <div>My Resources</div>
                                    <img src='/img/molecular_white.png' alt='colored shape' draggable="false">
                                </div>
                            </button>
                        </div>
                    </div>
                {:else}
                    <!-- user not logged in -->
                    <div class="flex-block-100">
                        <div class="text-3">Start Here.</div>
                        <div class="text-4">
                            Use the information provided by your employer to register or login. 
                            Search for resources available to support your caregiving needs and 
                            keep track of your resources anytime, from anywhere.
                        </div>
                        <div class="buttons-row">
                            <div class="login-button">
                                <LandingPageTextButton onClick={onLoginClick} label={'Login'} />
                            </div>        
                        </div>
                    </div>
                {/if}

            </div>
        </div>

        <div class="block-right">
            <img src='/img/landing_page_shape.svg' alt='colored shape' draggable="false">        
        </div>
    </div>
</div>
